import { render, staticRenderFns } from "./MainLedgerReports.vue?vue&type=template&id=685f3814&scoped=true"
import script from "./MainLedgerReports.vue?vue&type=script&lang=js"
export * from "./MainLedgerReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685f3814",
  null
  
)

export default component.exports